import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { LineKeysTypes } from '@frontend/api-line-keys';
import {
  DEVICE_LAYOUT_WIDTH,
  LAYOUT_HEIGHT_HEADER_FOOTER,
  LAYOUT_TOUCH_SCREEN_HEIGHT_HEADER_FOOTER,
  LINE_KEY_FONT_SIZE,
} from '../constants';
import { isHandheldLayout } from '../utils';
import { DeviceLayoutFooter } from './device-layout-footer';
import { DeviceLayoutHandheld } from './device-layout-handheld';
import { DeviceLayoutHeader } from './device-layout-header';
import { DeviceLayoutTouchScreen } from './device-layout-touch-screen';
import { DeviceLayoutWithSideKeys } from './device-layout-with-side-keys';

type Props = {
  isPreviewEnabled?: boolean;
  children: ReactNode;
  model: LineKeysTypes.ModelInfoType | undefined;
};

export const DeviceLayout = ({ model, isPreviewEnabled, children }: Props) => {
  return (
    <article className={`${model?.make}-${model?.model}`} css={layoutStyles({ isPreviewEnabled, model })}>
      {children}
    </article>
  );
};

DeviceLayout.Header = DeviceLayoutHeader;
DeviceLayout.LayoutWithKeys = DeviceLayoutWithSideKeys;
DeviceLayout.TouchScreen = DeviceLayoutTouchScreen;
DeviceLayout.Handheld = DeviceLayoutHandheld;
DeviceLayout.Footer = DeviceLayoutFooter;

const layoutStyles = ({
  isPreviewEnabled,
  model,
}: {
  isPreviewEnabled?: boolean;
  model?: LineKeysTypes.ModelInfoType;
}) => {
  const isHandheldDeviceLayout = isHandheldLayout(model);

  return css`
    background: var(--fabric-color-neutral-80);
    ${isHandheldDeviceLayout
      ? `
        position: relative;
        box-sizing: border-box;
        width: 100%;
        max-width: 356.2px;
        height: 552px;
        opacity: 1;
        margin: 0 auto;
        padding: 60px 23px 28px;
        overflow: hidden;
        border-top-left-radius: 40px;
        border-top-right-radius: 40px;
        border-bottom-right-radius: 16px;
        border-bottom-left-radius: 16px;
      `
      : `
        ${!isPreviewEnabled ? `max-width: ${DEVICE_LAYOUT_WIDTH};` : ''}
        height: max-content;
        border-radius: 16px;
        width: 100%;
      `}
    border: 2px solid var(--fabric-color-neutral-80);

    .device-model-layout-header {
      font-size: ${LINE_KEY_FONT_SIZE};
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .device-model-layout-header,
    .device-model-layout-footer {
      height: ${LAYOUT_HEIGHT_HEADER_FOOTER};
    }

    .device-model-layout-header.touch-screen,
    .device-model-layout-footer.touch-screen {
      height: ${LAYOUT_TOUCH_SCREEN_HEIGHT_HEADER_FOOTER};
    }

    .device-model-layout-header.handheld {
      position: absolute;
      top: 0;
      left: 23px;
      right: 23px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
    }

    .device-model-layout-footer.handheld {
      display: none;
    }

    ul {
      padding: 0;
    }
  `;
};
